$(document).ready(function(){
	$('.search-trigger').click(function() {

		$('.search_box').fadeToggle(100, function(){$('.search_box').css('width', '190px'); $('.search_box').focus();});
	});
	$('.search_box').blur(function() {
		$('.search_box').css('width', '0px');;
		$('.search_box').fadeOut(700);
	});
});

$(document).ready(function() {

    $('a.togglelink').on('click', function (e) {
        e.preventDefault();
        var elem = $(this).next('.toggle');
        elem.slideToggle('slow');
    });

    $('.btnToggle').on('click', function () {
        $('.fa-angle-double-right').toggleClass('rotate');
        $('.sidebar_list').toggleClass('sidebarActive');

    });



    $('.wrapFilter ul li a.faviconUpDown').on('click', function (title) {
        $('.fa-angle-up').toggleClass('fa-angle-down');
        title.preventDefault();
        var elem = $(this).next('.toggleSlider');
        elem.slideToggle('slow');
        $(".hideSortToggle").slideUp();
        $(".hideFilterToggle").slideUp();
        $(".clearAllSort").css("display", "none");
        $('.fullLengthFilter').addClass('col-xs-6');
        $('.sortingProduct').addClass('col-xs-6');
        $('.sortingProduct').removeClass('col-xs-12');
        $('.fullLengthFilter').removeClass('col-xs-10');
        $('.fullLengthFilter').addClass('text-center');
        $('.exitFilter').css("display", "none");
        $('.sortingProduct').css("display", "block");
        $('.fullLengthFilter').css("display", "block");
    });


    $('.filterProducts').on('click', function (filter) {
        $('.fltrPageTitle').slideUp('slow');
        filter.preventDefault();
        var elem = $(this).next('.filterToggling');
        elem.slideDown('slow');
        $('.sortingProduct').css("display", "none");
        $('.exitFilter').css("display", "block");
        $('.fullLengthFilter').removeClass('col-xs-6');
        $('.fullLengthFilter').removeClass('text-center');
        $('.fullLengthFilter').addClass('col-xs-11');
    });

    $('.exitFilter').on('click', function (exitFilter) {
        exitFilter.preventDefault();
        $('.hideFilterToggle').hide();
        $('.exitFilter').css("display", "none");
        $('.sortingProduct').css("display", "block");
        $('.fullLengthFilter').addClass('col-xs-6');
        $('.fullLengthFilter').removeClass('col-xs-11');
        $('.hideSortToggle').slideUp();
        $('.fullLengthFilter').addClass('text-center');
    });

    $('.cancelSort').on('click', function () {
        $('.sortingToggle').hide();
        $('.sortingProduct').css("display", "block");
        $('.sortingProduct').removeClass('col-xs-12');
        $('.sortingProduct').addClass('col-xs-6');
        $('.fullLengthFilter').css("display", "block");
        $('.clearAllSort').css("display", "none");
    });

    $('.sortProducts').on('click', function (sortProducts) {
        $(".hidePageTitle").slideUp();
        sortProducts.preventDefault();
        var elem = $(this).next('.sortingToggle');
        elem.slideDown('slow');
        $('.fullLengthFilter').css("display", "none");
        $('.sortingProduct').removeClass('col-xs-6');
        $('.sortingProduct').addClass('col-xs-12');
        $('.clearAllSort').css("display", "block");
    });

    $('.wrapFilter ul li a.dskTitle').on('click', function () {
        $('.fa-angle-up').toggleClass('fa-angle-down');
        $(".fltrPageTitle").slideToggle();
    });
    
        $('.footerTitleFav').on('click', function () {
        $(this).find('.fa-angle-up').toggleClass('fa-angle-down'); 
    });


    $('.dropDownHeaders').click(function () {
        $('.hidePageTitle').slideUp();
    });

    $('.dropdown-submenu a.indivSize').on("click", function (sizeDrop) {
        $('.indivSize').next('ul').hide();
        var title = $(this);
        title.next('ul').show();
        sizeDrop.stopPropagation();
        sizeDrop.preventDefault();
    });

});








$(document).ready(function() {

  	$('.navbar-toggle').on('click', function () {
  		 event.preventDefault();
                 $(".fadeBlurBackground").addClass("activeBlurBackground");
  		$('.icon-bar').slideToggle(200);
		$('.fa-times').slideToggle(200);
		$(this).toggleClass('leftCollabse');
		$('.rightNavSection').toggleClass('leftCollabseRightNav');
		$('.container-fluid').toggleClass('PositionRelative');
		$('html, body').toggleClass('bodyUncrollable');
		$('.offcanvasCart').removeClass('activeCart');
		// $('.navbar-nav').focus()
  	});
//   	$('.navbar-nav').mouseleave(function(){
//   		 event.preventDefault();
// 		 $navMenuCont = $($('[data-toggle="slide-collapse"]').data('target'));

// 		$('.icon-bar').slideToggle(200);
// 		$('.fa-times').slideToggle(200);
// 		$('.navbar-toggle').toggleClass('leftCollabse');
// 		$('.rightNavSection').toggleClass('leftCollabseRightNav');
// 		$navMenuCont.toggleClass('menuTog');
// });

});


$(document).ready(function() {
$('[data-toggle="slide-collapse"]').click(function() {
	    $navMenuCont = $($(this).data('target'));
    $navMenuCont.toggleClass('menuTog');
    $('.allMobileUL').toggleClass('mobileWidthMenuBar');
    
});
});


// $('[data-toggle="slide-collapse"]').on('click', function() {
//     $navMenuCont = $($(this).data('target'));
//     $navMenuCont.animate({'left':'toggle'}, 600);

//     });
